import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { getIntlLocale } from "@/lib/locale";
import { translate, type TranslationKey } from "@/lib/translation";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const WEEKDAY_KEYS: TranslationKey[] = [
  "common:weekdays.long.sun",
  "common:weekdays.long.mon",
  "common:weekdays.long.tue",
  "common:weekdays.long.wed",
  "common:weekdays.long.thu",
  "common:weekdays.long.fri",
  "common:weekdays.long.sat",
];

// Formats a "prices as of" timestamp, prefixing the weekday when the timestamp
// isn't from today (e.g. stale weekend prices showing a Friday close time).
export function formatPriceAsOf(
  isoString: string,
  now: Date = new Date(),
): string {
  const date = new Date(isoString);
  const time = date.toLocaleTimeString(getIntlLocale(undefined), {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  if (isToday) return time;
  return `${translate(WEEKDAY_KEYS[date.getDay()])} ${time}`;
}
